import * as React from 'react';

const Spinner = () => {
  return (
    <div className="loader-wrapper">
      <div className="loader__spinner" />
      <div className="loader__text">Ladataan...</div>
    </div>
  );
};

export default Spinner;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Spinner.tsx